var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheHangedMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.27 422.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.65,
    y1: 396.08,
    x2: 114.1,
    y2: 234.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 233.8,
    y1: 118.83,
    x2: 172.65,
    y2: 396.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.55,
    y1: 118.83,
    x2: 233.8,
    y2: 118.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.65,
    y1: 19.13,
    x2: 172.65,
    y2: 396.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.98 247.07 105.64 232.99 101.89 215.74 115.97 226.4 133.22 222.65 122.56 236.73 126.31 253.98 112.23 243.32 94.98 247.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.68 4.09 172.13 10.49 187.7 2.16 181.3 18.61 189.63 34.18 173.18 27.78 157.61 36.11 164 19.66 155.68 4.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.08 112.26 229.71 111.19 240.37 97.12 241.44 114.74 255.51 125.4 237.89 126.47 227.23 140.55 226.16 122.92 212.08 112.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.77 125.16 16.96 114.66 18.22 97.05 28.73 111.24 46.34 112.5 32.15 123.01 30.88 140.62 20.38 126.43 2.77 125.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.93 405.61 163.98 395.28 154.04 382.9 169.02 388.17 174.77 373.37 177.69 388.97 193.38 386.56 181.33 396.89 191.26 409.27 176.29 404 170.54 418.79 167.62 403.19 151.93 405.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheHangedMan);
export default __webpack_public_path__ + "static/media/TheHangedMan.8d2f94c96b8027f1df6f690de88e7e4f.svg";
export { ForwardRef as ReactComponent };